import {
  MeetingCallRequest,
  MeetingExcludeRequest,
  MeetingGetByIdRequest,
  MeetingJoinRequest,
  MeetingJoinWaitingRoomRequest,
  MeetingLeaveRequest, MeetingMessageCreateRequest,
  MeetingMessageDeleteRequest,
  MeetingMessageGetRequest,
  MeetingMessageOnCreateEvent,
  MeetingMessageOnDeleteEvent,
  MeetingMessageOnReactionEvent,
  MeetingMessageOnUpdateEvent,
  MeetingMessageReactionRequest,
  MeetingMessageUpdateRequest, MeetingOnExcludeEvent,
  MeetingOnJoinEvent,
  MeetingOnLeaveEvent,
  MeetingRoomJoinRequest,
  MeetingRoomLeaveRequest,
  MeetingSessionCustomEventRequest,
  MeetingSessionMediaOnUpdateEvent,
  MeetingSessionMediaUpdateRequest,
  MeetingSessionOnCustomEvent,
  MeetingSessionOnStatsEvent,
  MeetingSessionOnUpdateEvent, MeetingSessionUpdateRequest,
  MeetingUserDataUpdateRequest,
  MeetingUpdateByIdRequest,
} from "@kalyzee/kast-web-sdk/websocket";
import { createAction } from "@reduxjs/toolkit";
import { MeetingSessionExtra } from "../../interfaces/meeting";
import { RTCStreamStatsResult } from "@kalyzee/kast-web-sdk/webrtc";

const ACTION_PREFIX = "socket_meeting_";

const socketMeetingActions = {
  getById: createAction<MeetingGetByIdRequest>(`${ACTION_PREFIX}get_by_id`),
  join: createAction<MeetingJoinRequest>(`${ACTION_PREFIX}join`),
  joinWaitingRoom: createAction<MeetingJoinWaitingRoomRequest>(`${ACTION_PREFIX}join_waiting_room`),
  leaveWaitingRoom: createAction<MeetingRoomLeaveRequest>(`${ACTION_PREFIX}leave_waiting_room`),
  leave: createAction<MeetingLeaveRequest>(`${ACTION_PREFIX}leave`),
  // call: createAction<MeetingCallRequest>(`${ACTION_PREFIX}call`),
  exclude: createAction<MeetingExcludeRequest>(`${ACTION_PREFIX}exclude`),
  updateSessionById: createAction<{ data: MeetingSessionUpdateRequest<MeetingSessionExtra>; storeResult?: boolean }>(`${ACTION_PREFIX}update_session_by_id`),
  publishCustomEventSession: createAction<{ data: MeetingSessionCustomEventRequest }>(`${ACTION_PREFIX}publish_custom_event_session`),
  sessionStats: createAction<{ meetingId: string; sessionId: string; stats: { [meetingId: string]: RTCStreamStatsResult } }>(`${ACTION_PREFIX}session_stats`),
  updateSessionMediaById: createAction<{ data: MeetingSessionMediaUpdateRequest; storeResult?: boolean }>(`${ACTION_PREFIX}update_session_media_by_id`),
  getMessages: createAction<{ data: MeetingMessageGetRequest; storeResult?: boolean }>(`${ACTION_PREFIX}get_messages`),
  createMessage: createAction<{ data: MeetingMessageCreateRequest; storeResult?: boolean }>(`${ACTION_PREFIX}create_message`),
  updateMessage: createAction<{ data: MeetingMessageUpdateRequest; storeResult?: boolean }>(`${ACTION_PREFIX}update_mesage`),
  deleteMessage: createAction<{ data: MeetingMessageDeleteRequest; storeResult?: boolean }>(`${ACTION_PREFIX}delete_message`),
  setMessageReaction: createAction<{ data: MeetingMessageReactionRequest; storeResult?: boolean }>(`${ACTION_PREFIX}set_message_reaction`),
  joinRoom: createAction<MeetingRoomJoinRequest>(`${ACTION_PREFIX}join_room`),
  leaveRoom: createAction<MeetingRoomLeaveRequest>(`${ACTION_PREFIX}leave_room`),
  updateUserData: createAction<MeetingUserDataUpdateRequest>(`${ACTION_PREFIX}update_user_data`),
  updateState: createAction<Pick<MeetingUpdateByIdRequest, 'id' | 'state'>>(`${ACTION_PREFIX}update_state`),
  onJoin: createAction<MeetingOnJoinEvent>(`${ACTION_PREFIX}on_join`),
  onLeave: createAction<MeetingOnLeaveEvent>(`${ACTION_PREFIX}on_leave`),
  onExclude: createAction<MeetingOnExcludeEvent>(`${ACTION_PREFIX}on_exclude`),
  onSessionUpdate: createAction<MeetingSessionOnUpdateEvent>(`${ACTION_PREFIX}on_session_update`),
  onSessionCustomEvent: createAction<MeetingSessionOnCustomEvent>(`${ACTION_PREFIX}on_session_custom_event`),
  onSessionStats: createAction<MeetingSessionOnStatsEvent>(`${ACTION_PREFIX}on_session_stats`),
  onSessionMediaUpdate: createAction<MeetingSessionMediaOnUpdateEvent>(`${ACTION_PREFIX}on_session_media_update`),
  onCreateMessage: createAction<MeetingMessageOnCreateEvent>(`${ACTION_PREFIX}on_create_message`),
  onUpdateMessage: createAction<MeetingMessageOnUpdateEvent>(`${ACTION_PREFIX}on_update_message`),
  onDeleteMessage: createAction<MeetingMessageOnDeleteEvent>(`${ACTION_PREFIX}on_delete_message`),
  onMessageReaction: createAction<MeetingMessageOnReactionEvent>(`${ACTION_PREFIX}on_message_reaction`),
};

export default socketMeetingActions;
